import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import MaterialUiInput from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'

import * as Constants from '../../helpers/Constants'

class Input extends Component {
  constructor(props) {
    super(props)
    this.input = React.createRef()
  }

  componentDidMount() {
    if (this.props.onRef) this.props.onRef(this)
  }

  componentWillUnmount() {
    if (this.props.onRef) this.props.onRef(undefined)
  }

  focus() {
    this.input.focus()
  }

  render() {
    const {
      placeholder = '',
      type = 'text',
      value,
      onChange = () => {},
      disabled,
      classes,
      error = '',
      onKeyPress,
      multiline,
      rows,
      rowsMax,
      onFocus = () => {},
      onBlur = () => {}
    } = this.props
    return (
      <FormControl className={classes.container}>
        <InputLabel
          FormLabelClasses={{
            root: classes.cssLabel,
            focused: classes.cssFocused
          }}
        >
          {placeholder}
        </InputLabel>
        <MaterialUiInput
          onKeyPress={onKeyPress}
          classes={{
            underline: classes.cssUnderline
          }}
          inputRef={input => {
            this.input = input
          }}
          type={type}
          value={value}
          onChange={event => onChange(event.target.value)}
          disabled={disabled}
          error={error !== ''}
          multiline={multiline}
          rows={rows}
          rowsMax={rowsMax}
          onFocus={() => onFocus()}
          onBlur={() => onBlur()}
        />
        <FormHelperText id={'name-error-text'}>{error}</FormHelperText>
      </FormControl>
    )
  }
}

const Styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 15
  },
  cssLabel: {
    '&$cssFocused': {
      color: 'rgba(0, 0, 0, 0.54)'
    }
  },
  cssFocused: {},
  cssUnderline: {
    '&:after': {
      borderBottomColor: Constants.WHITE_LABEL.colors.primary
    }
  }
}

export default withStyles(Styles)(Input)



// WEBPACK FOOTER //
// ./src/components/common/Input.js